// extracted by mini-css-extract-plugin
export default {"overlay-container":"Overlay_overlay-container__GCiBW","overlay":"Overlay_overlay__kMK4w","active":"Overlay_active__ubWpU","inactive":"Overlay_inactive__riht0"};